import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import CloseAccountSuccessfulEN from 'components/GlobalModals/CloseAccountSuccessful/locales/CloseAccountSuccessful_en_US';
import CloseAccountSuccessfulFR from 'components/GlobalModals/CloseAccountSuccessful/locales/CloseAccountSuccessful_fr_CA';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(CloseAccountSuccessfulEN, CloseAccountSuccessfulFR);

const fields = createStructuredSelector({
    localization: createStructuredSelector({
        accountClosed: getTextFromResource(getText, 'accountClosed'),
        loggedOut: getTextFromResource(getText, 'loggedOut'),
        message: getTextFromResource(getText, 'message'),
        or: getTextFromResource(getText, 'or'),
        chatWithUs: getTextFromResource(getText, 'chatWithUs')
    })
});

const withCloseAccountSuccessfulProps = wrapHOC(connect(fields, null));

export {
    withCloseAccountSuccessfulProps, fields
};
